


















































import { Component, Vue } from 'vue-property-decorator';
import { Work as WorkInterface } from 'portfolio';

@Component({
  props: {
    data: {
      type: Object as () => WorkInterface
    }
  }
})
export default class WorkItem extends Vue {
  publicPath: string = process.env.BASE_URL

  getJobPref(): string {
    switch (this.$props.data.job.type) {
      case 'personal':
        return ' personal project '

      case 'school':
        return ' school project '

      case 'internship':
        return ' intern at ';

      case 'employment':
        return ' employed by '

      case 'freelance':
        return ' client ';

      default:
        return ' for ';
    }
  }

  handleClick(e: Event): void {
    const n = document.querySelector(`#${this.$props.data.id} a.work-link`);

    if (n) {
      const evt = new MouseEvent('click');
      n.dispatchEvent(evt);
    }
  }

  handleJobClick(e: Event): void {
    const n = document.querySelector(`#${this.$props.data.id} a.job-link`);

    if (n) {
      const evt = new MouseEvent('click');
      n.dispatchEvent(evt);
    }
  }
}
